import React from "react";
import AddDepartment from "./AddDep";


const Department = () => {
	return (
		<>
			<AddDepartment />
		</>
	);
};

export default Department;
